<template>
  <div class="p-recruit">
    <div class="__ban kf-animate kf-animate-img">
      <div class="__ban_cap">人才招聘</div>
    </div>
    <div class="p-recruit_per">
      <div class="g-box">
        <div class="__head">
          <div class="__head_cap">人才培养</div>
          <div class="__head_tit">/ Personnel training</div>
        </div>
        <div class="__list">
          <div class="__list_item">
            <div class="__list_img n1"></div>
            <div class="__list_cap">华博特大学</div>
            <div class="__list_text">
              华博特专业讲师队伍，结合线上、线下培训项目，让你随时随地，想学就学，助力职业生涯各个阶段的成长发展
            </div>
          </div>
          <div class="__list_item">
            <div class="__list_img n2"></div>
            <div class="__list_cap">新员工培训</div>
            <div class="__list_text">
              我们为每一位新员工准备了分阶段培养
              项目，针对不同职类、不同部门采取定
              制化培养内容，通过多样化教学方式结
              合，带领新员工快速掌握专业技能、业 务知识等
            </div>
          </div>
          <div class="__list_item">
            <div class="__list_img n3"></div>
            <div class="__list_cap">管理层培训</div>
            <div class="__list_text">
              无论是新晋经理、中层干部等，华博特
              分层级、分阶段定制管理提升课程表，
              提升管理水平、领导魅力、战略经营思
              维，更开设企业总裁管理研修班，助力 优秀人才更进一步！
            </div>
          </div>
          <div class="__list_item">
            <div class="__list_img n4"></div>
            <div class="__list_cap">内部人才流动</div>
            <div class="__list_text">
              公司岗位内部开放，只要符合条件，可
              以申请转岗，更多有趣、更多挑战、更 多可能
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-recruit_job">
      <div class="g-box">
        <div class="__head">
          <div class="__head_cap">招聘信息</div>
          <div class="__head_tit">/ Recruitment information</div>
        </div>
        <div class="__bd">
          <!--          <div class="__side">-->
          <!--            <div class="__side_box">-->
          <!--              <div class="__side_hd">筛选</div>-->
          <!--              <div class="__side_list">-->
          <!--                <div class="__side_list_cap">工作城市</div>-->
          <!--                <div class="__side_list_item">-->
          <!--                  <div class="__side_list_link m-a on">杭州市</div>-->
          <!--                </div>-->
          <!--                <div class="__side_list_item">-->
          <!--                  <div class="__side_list_link m-a">杭州市</div>-->
          <!--                </div>-->
          <!--                <div class="__side_list_item">-->
          <!--                  <div class="__side_list_link m-a">杭州市</div>-->
          <!--                </div>-->
          <!--              </div>-->
          <!--            </div>-->
          <!--          </div>-->
          <div class="__main">
            <div v-for="(item, index) in list" :key="index" class="__main_box">
              <div class="__main_hd">
                <div class="__main_hd_left">
                  <div class="__main_hd_cap">{{ item.name }}</div>
                  <div class="__main_hd_tit">{{ item.department }}</div>
                  <div class="__main_hd_det">
                    <span>工作城市：{{ item.address }}</span>
                    <span
                      >更新时间：{{
                        $Tools.time(item.createTime, "yyyy-MM-dd")
                      }}</span
                    >
                  </div>
                </div>
                <div class="__main_hd_right mla">
                  <div class="__main_hd_more m-h" @click="getEmailShow">
                    申请职位
                  </div>
                  <div
                    class="__main_hd_pos m-h on"
                    v-if="ind === index"
                    @click="ind = ''"
                  >
                    收起<i></i>
                  </div>
                  <div class="__main_hd_pos m-h" v-else @click="ind = index">
                    展开<i></i>
                  </div>
                </div>
              </div>
              <div class="__main_bd" v-if="ind === index">
                <div class="__main_bd_cap">岗位职责</div>
                <div class="__main_bd_text" v-html="item.responsibility"></div>
                <div class="__main_bd_cap">任职要求</div>
                <div class="__main_bd_text" v-html="item.requirement"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="p-recruit_exc">
      <div class="g-box">
        <div class="__head">
          <div class="__head_cap">优秀员工</div>
          <div class="__head_tit">/ Excellent staff</div>
        </div>
        <div class="__list">
          <div v-for="(item, index) in list_2" :key="index" class="__list_item">
            <div
              class="__list_img"
              :style="{
                backgroundImage: 'url(' + item.image + ')',
              }"
            ></div>
            <div class="__list_hd">
              <div class="__list_cap">{{ item.name }}</div>
              <div class="__list_tit">/ {{ item.station }}</div>
            </div>
            <div class="__list_text">{{ item.title }}</div>
          </div>
        </div>
      </div>
    </div>

    <!--投递建立至邮箱-->
    <div class="p-recruit_email" v-if="emailShow">
      <div class="__make" @click="emailShow = false"></div>
      <div class="__box">
        <div class="__cap">投递建立至邮箱</div>
        <div class="__bd">{{ email }}</div>
        <div class="__ft">
          <div class="__btn m-a" @click="copyEmail" v-if="email">复制邮箱</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import page_mx from "@/mixin/page_mx";

export default {
  mixins: [page_mx],
  data() {
    return {
      ind: "",
      emailShow: false,
      list_2: [],
      email: "",
    };
  },
  components: {},
  methods: {
    async init() {
      this.$api.cms.web.jobPosition_listForClient.get().then((res) => {
        this.list = res.data;
      });
      this.$api.cms.web.coworker_listForClient.get().then((res) => {
        this.list_2 = res.data;
      });

      this.email = await this.getMenuConfig("投递邮箱", "title");
      console.log(this.email);
    },
    getEmailShow() {
      this.emailShow = true;
    },
    copyEmail() {
      this.$Tools.copyText(this.email);
    },
  },
};
</script>
<style lang="less">
.p-recruit {
  .__ban {
    background: url("../../assets/img/ico_7.png") no-repeat center;
    background-size: cover;
    height: 280px;
    display: flex;
  }
  .__ban_cap {
    margin: auto;
    font-size: 60px;
    font-weight: 400;
    color: #ffffff;
    line-height: 84px;
    letter-spacing: 0.7em;
  }
  .__head {
    display: flex;
    align-items: flex-end;
    line-height: 1;
    padding-bottom: 22px;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      left: 0;
      bottom: 0;
      width: 40px;
      height: 2px;
      background: #0030aa;
    }
  }
  .__head_cap {
    font-size: 24px;
    color: #000000;
  }
  .__head_tit {
    font-size: 14px;
    color: #a8aab8;
    margin-left: 10px;
  }
}
.p-recruit_per {
  padding: 80px 0;
  .__list {
    display: flex;
    margin-top: 80px;
  }
  .__list_item {
    width: 200px;
    flex-shrink: 0;
    margin-right: 100px;
    &:nth-child(4n) {
      margin-right: 0;
    }
  }
  .__list_img {
    width: 200px;
    height: 200px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
    &.n1 {
      background-image: url("../../assets/img/ico_8.png");
    }
    &.n2 {
      background-image: url("../../assets/img/ico_9.png");
    }
    &.n3 {
      background-image: url("../../assets/img/ico_10.png");
    }
    &.n4 {
      background-image: url("../../assets/img/ico_11.png");
    }
  }
  .__list_cap {
    font-size: 18px;
    color: #0030aa;
    line-height: 25px;
    margin-top: 20px;
    text-align: center;
  }
  .__list_text {
    font-size: 14px;
    color: #656878;
    line-height: 20px;
    margin-top: 20px;
  }
}
.p-recruit_job {
  background: #f2f4f9;
  padding: 80px 0;
  .__bd {
    display: flex;
    margin-top: 60px;
  }
  .__side {
    flex-shrink: 0;
    width: 200px;
  }
  .__side_box {
    background: #ffffff;
    border-radius: 2px;
  }
  .__side_hd {
    font-size: 16px;
    color: #656878;
    line-height: 22px;
    padding: 14px 20px;
    border-bottom: 1px solid #f2f4f9;
  }
  .__side_list {
    padding: 10px 20px;
  }
  .__side_list_cap {
    font-size: 14px;
    color: #656878;
    line-height: 20px;
  }
  .__side_list_item {
    padding: 5px 0;
  }
  .__side_list_link {
    display: inline-block;
    font-size: 12px;
    color: #656878;
    line-height: 17px;
    &.on {
      color: #ff8012;
    }
  }
  .__main {
    flex-grow: 1;
    //margin-left: 30px;
  }
  .__main_box {
    background: #ffffff;
    & + .__main_box {
      margin-top: 20px;
    }
  }
  .__main_hd {
    display: flex;
    padding: 20px 25px;
  }
  .__main_hd_left {
    margin-right: 20px;
  }
  .__main_hd_cap {
    font-size: 20px;
    color: #000000;
    line-height: 28px;
  }
  .__main_hd_tit {
    font-size: 14px;
    color: #656878;
    line-height: 20px;
    margin-top: 10px;
  }
  .__main_hd_det {
    display: flex;
    margin-top: 20px;
    font-size: 12px;
    font-weight: 400;
    color: #a8aab8;
    line-height: 17px;
    span {
      margin-right: 20px;
    }
  }
  .__main_hd_right {
    display: flex;
    flex-direction: column;
  }
  .__main_hd_more {
    width: 96px;
    height: 36px;
    background: #ff8012;
    border-radius: 2px;
    font-size: 14px;
    color: #ffffff;
    line-height: 36px;
    text-align: center;
  }
  .__main_hd_pos {
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #0030aa;
    line-height: 17px;
    margin-left: auto;
    margin-top: auto;
    i {
      background: url("../../assets/img/ico_12_2.png") no-repeat;
      width: 16px;
      height: 16px;
      margin-left: 4px;
    }
    &.on {
      color: #656878;
      i {
        background-image: url("../../assets/img/ico_12.png");
      }
    }
  }
  .__main_bd {
    padding: 20px 25px 30px 25px;
    border: 1px solid #f2f4f9;
  }
  .__main_bd_cap {
    font-size: 16px;
    color: #000000;
    line-height: 22px;
  }
  .__main_bd_text {
    font-size: 14px;
    color: #656878;
    line-height: 26px;
    margin-top: 10px;
    & + .__main_bd_cap {
      margin-top: 20px;
    }
  }
  .kf-pagination {
    text-align: center;
    margin-top: 40px;
  }
}
.p-recruit_exc {
  padding: 60px 0 120px 0;
  .__list {
    display: flex;
    flex-wrap: wrap;
    padding-top: 20px;
  }
  .__list_item {
    width: 210px;
    flex-shrink: 0;
    margin-right: 86px;
    margin-top: 40px;
    &:nth-child(4n) {
      margin-right: 0;
    }
    &:hover {
      .__list_img {
        transform: scale(1.05);
      }
    }
  }
  .__list_img {
    width: 210px;
    height: 280px;
    border-radius: 2px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    transition: all 0.2s;
  }
  .__list_hd {
    display: flex;
    align-items: flex-end;
    line-height: 1;
    margin-top: 20px;
  }
  .__list_cap {
    font-size: 20px;
    color: #292a32;
    white-space: nowrap;
  }
  .__list_tit {
    font-size: 14px;
    color: #a8aab8;
    margin-left: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .__list_text {
    font-size: 14px;
    color: #656878;
    line-height: 20px;
    margin-top: 10px;
  }
}
.p-recruit_email {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 101;
  display: flex;
  .__make {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.2);
  }
  .__box {
    margin: auto;
    width: 360px;
    background: #ffffff;
    box-shadow: 0 2px 16px 0 rgba(168, 170, 184, 0.22);
    position: relative;
    z-index: 1;
  }
  .__cap {
    text-align: center;
    font-size: 20px;
    color: #000000;
    line-height: 28px;
    margin-top: 20px;
  }
  .__bd {
    text-align: center;
    font-size: 18px;
    color: #656878;
    line-height: 25px;
    margin-top: 40px;
  }
  .__ft {
    text-align: center;
    padding-bottom: 35px;
  }
  .__btn {
    display: inline-block;
    font-size: 16px;
    color: #0030aa;
    line-height: 22px;
    margin-top: 30px;
  }
}
</style>
